import type {ReactElement} from 'react';
import React from 'react';
import type {BaseControlItem} from '@Components/contextual-menu/components/controls';
import {Controls} from '@Components/contextual-menu/components/controls';
import {Option} from '@Components/contextual-menu/components/option';

interface ContextualMenuControlsOptionProps {
  id: string;
  className?: string;
  data: BaseControlItem[];
  isCenterAligned?: boolean;
  wrapItems?: boolean;
  containerClassName?: string;
  itemsClassName?: string;
  optionsContainerClassName?: string;
  onClick?(id: string): void;
}

export function ContextualMenuControlsOption({
  className = '',
  wrapItems = false,
  onClick = (): void => {},
  isCenterAligned = false,
  containerClassName = '',
  itemsClassName = '',
  optionsContainerClassName = '',
  ...props
}: ContextualMenuControlsOptionProps): ReactElement {
  return (
    <Option
      key={props.id}
      showControlInCenter
      className={className}
      containerClassName={optionsContainerClassName}
      optionControl={
        <Controls itemsClassName={itemsClassName} className={containerClassName} onClick={onClick} wrapItems={wrapItems} isCenterAligned={isCenterAligned} items={props.data} />
      }
    />
  );
}
